module.exports = __webpack_public_path__ + "img/2257928615a377d09c5093bdb5659b56.png";